//@flow
import React, { Component } from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import createMuiTheme from "material-ui/styles/createMuiTheme";
import lightGreen from "material-ui/colors/lightGreen";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import {LinearProgress} from "material-ui/Progress";
import LightBulb from "material-ui-icons/LightbulbOutline";

import Cookies from "js-cookie";

import LangSelection from "./LangSelection";
import DropField from "./DropField";
import LiveImage from "./LiveImage";

import Actions from './actions';

/*
import injectTapEventPlugin from 'react-tap-event-plugin';
// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();
*/

const muiTheme = createMuiTheme({
  palette: {
    primary: lightGreen
  },
  appBar: {
    height: 50
  }
});



class App extends Component<{}, *> {
  state = {
    originalLang: Cookies.get().oL || "_detect",
    targetLang: Cookies.get().tL || navigator.language.split("-")[0] || "en",
    imgSrc: null,
    imgData: null,
    annotations: null,
    loading: false,
    langs: [],
  };

  _bindState = (key: string) => {
    return (event: Object) => {
      this.setState({ [key]: event.target.value });
    };
  };

  componentDidMount() {
    if (window.adsbygoogle) window.adsbygoogle.push({});
    Actions.APP = this;
  }
  addToMRU(list:Array<string>, current:string) {
    var ret = [current];
    for (var i = 0; i < list.length; i++) {
      if (i > 3) break;
      if (list[i] === current) continue;
      ret.push(list[i]);
    }
    return ret;
  }

  onChangedImage = (imgSrc: ?string, imgData: ?string) => {
    Cookies.set('oL', this.state.originalLang);
    Cookies.set('tL', this.state.targetLang);

    var oRecent = [];
    if (Cookies.get().oMRU) oRecent = JSON.parse(Cookies.get().oMRU);
    if (!oRecent instanceof Array || !oRecent.length) {
      oRecent = ["_detect"];
    }
    var tRecent = [];
    if (Cookies.get().tMRU) tRecent = JSON.parse(Cookies.get().tMRU);
    if (!tRecent instanceof Array || !tRecent.length) {
      tRecent = ["en"];
    }

    oRecent = this.addToMRU(oRecent, this.state.originalLang);
    tRecent = this.addToMRU(tRecent, this.state.targetLang);
    Cookies.set('oMRU', JSON.stringify(oRecent));
    Cookies.set('tMRU', JSON.stringify(tRecent));

    if (imgSrc !== null && imgData !== null)
      this.setState({ imgSrc: imgSrc, imgData: imgData });

  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.imgData !== this.state.imgData ||
      prevState.originalLang !== this.state.originalLang
    )
      if (this.state.imgData) Actions.updateVisionAction( this.state.originalLang, this.state.imgData);
  }


  render() {
    return (
      <MuiThemeProvider theme={muiTheme}>
        <div className="App">
          <AppBar>
            <Toolbar style={{ maxWidth: 1220, margin: 'auto', width: '100%' }}>
              <img src="//translate-image.com/favicon-96x96.png" style={{width:24,marginRight:10}} />
              <Typography type="title" style={{ flex: 1 }}>
                Translate Image
              </Typography>
              <Button component="a" href="https://docs.google.com/forms/d/e/1FAIpQLSdERmnSuoiFFRSnewky5E3nTRb9Zfu0VGUrE79oZM-Tx0-0DQ/viewform">Feedback&nbsp;</Button>
            </Toolbar>
            {this.state.loading && <LinearProgress />}
          </AppBar>
          <LangSelection
              langs={this.state.langs}
              originalLang={this.state.originalLang}
              targetLang={this.state.targetLang}
              onChangeOriginal={this._bindState("originalLang")}
              onChangeTarget={this._bindState("targetLang")}
              />

            <DropField
              imgSrc={this.state.imgSrc}
              onChangedImage={this.onChangedImage}
              />

              <ins className="adsbygoogle"
            style={{ display: 'block' }}
       data-ad-client="ca-pub-9963447484807015"
       data-ad-slot="8902922934"
       data-ad-format="auto"></ins>
       {this.state.imgData && <span className='help'> <LightBulb /> Drag a selection around the outlined text to translate</span>}
          <LiveImage
            annotations={this.state.annotations}
            originalLang={this.state.originalLang}
            targetLang={this.state.targetLang}
            imgData={this.state.imgData}
            translatedText={this.state.translatedText}
          />
          <center><p style={{ fontSize: 12 }}>Enjoying Translate Image? BTC: 1836AufMqjyoGUNmLdBxG5EtEfrRcn5yYM<br/>LTC: LcXG32GeyK5ExHeWzkiDicnSBFuT13562E<br/>BCH: 1JEyVzcE9n2ppJdG8ycjQ6dHxFGC9jQopW</p></center>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js